var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"abr-view"},[_c('div',{ref:"plot",staticClass:"abr-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }